import { render, staticRenderFns } from "./PPhilosophy.vue?vue&type=template&id=0d438e60&"
import script from "./PPhilosophy.vue?vue&type=script&lang=ts&"
export * from "./PPhilosophy.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports